export enum RoleTypes {
  ENUMERATOR = "Enumerator",
  RECRUITER = "Recruiter",
}
